import {Observable} from "rxjs";
import {Request} from "../request.abstract";
import {Role} from "./api.models";
import {PermissionsEndpoint} from "./permissions/api.service";
import {Observer} from "rxjs/Observer";

export class RolesEndpoint extends Request {
    protected cache: Role[];
    protected cacheToken: string;

    collection(): Observable<Role[]> {
        return Observable.create((observer: Observer<any>) => {
            if (this.cache && this.cacheToken === this.settings.token) {
                observer.next(this.cache);
                observer.complete();

                return;
            }

            this.get('/v1/roles').subscribe(
                (roles: Role[]) => {
                    this.cache      = [];
                    this.cacheToken = this.settings.token;
                    roles.forEach((role: Role) => {
                        this.cache.push(Object.assign(role));
                    });

                    observer.next(roles);
                },
                (error: any) => {
                    observer.error(error);
                },
                () => {
                    observer.complete();
                }
            );
        });
    }

    add(role: Role): Observable<Role> {
        this.cache = null;

        return this.post('/v1/roles', role);
    }

    update(role: Role): Observable<Role> {
        this.cache = null;

        return this.patch('/v1/roles/' + role.id, role);
    }

    remove(id: number): Observable<Boolean> {
        this.cache = null;

        return this.delete('/v1/roles/' + id);
    }

    permissions(id: number): PermissionsEndpoint {
        return new PermissionsEndpoint(this.http, this.settings, id);
    }
}



// WEBPACK FOOTER //
// ./~/angular2-template-loader!./~/@angularclass/hmr-loader!./src/app/shared/api/roles/api.service.ts